<template>
  <b-container fluid >
    <template v-for="(widget, index) in widgetData.widgets">
      <b-col class="column" :cols="widget.columns" :key="index">
        <widget-inner :widget-data="widget"/>
      </b-col>
    </template>
  </b-container>
</template>

<script>

export default {
  name: 'Widget',

    components: {
        'widget-inner': () => import('./Widget.vue')
    },

    data() {
        return {}
  },

  props: {
    widgetData: Object
  },

  computed: {
//    ...mapGetters(['pages'])
//    ...mapState([])
  },

  methods: {
  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .column {
    background-color: #dddddd;
}
  .dynrow {
    margin-top: 1em;
  }


</style>
